import type { DraftReservationVM, PresentationResult } from './types.ts';

/**
 * AI-drafted reservation — intentionally empty.
 *
 * The reservations API (`packages/api-client/src/queries/reservations.ts`) has
 * no "AI draft awaiting confirm/hold" surface: the `Reservation` schema carries
 * no guest name or rate, and there is no confirm/hold mutation. Rather than
 * fabricate a guest and ship dead Confirm/Hold buttons, this returns no draft
 * and `ReceptionAside` hides the panel entirely. Wire a real query here once the
 * backend exposes drafted reservations.
 */
export function useDraftReservation(
  _tenantId: string,
  _hotelId: string,
): PresentationResult<DraftReservationVM> {
  return { data: undefined, isLoading: false, isError: false };
}
